/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { LocalViewId } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationView.types.tsx';
import { updateContainerState } from './updateContainerState.tsx';

export const renameViewSet =
	(localId: LocalViewId): Action<State, Props> =>
	async ({ setState, getState }, props) => {
		const { navigationRemote, cloudId, containerId } = props;
		if (
			!cloudId ||
			!containerId ||
			!navigationRemote ||
			getState().containers[containerId]?.isLoading ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}

		setState(
			updateContainerState(getState(), containerId, {
				views: [
					...getState().containers[containerId].views.map((view) =>
						view.localId === localId ? { ...view, isRenaming: true } : view,
					),
				],
			}),
		);
	};

export const cancelViewSetRenaming =
	(localId: LocalViewId): Action<State, Props> =>
	async ({ setState, getState }, props) => {
		const { navigationRemote, cloudId, containerId } = props;
		if (
			!cloudId ||
			!containerId ||
			!navigationRemote ||
			getState().containers[containerId]?.isLoading ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}

		setState(
			updateContainerState(getState(), containerId, {
				views: [
					...getState().containers[containerId].views.map((view) =>
						view.localId === localId ? { ...view, isRenaming: false } : view,
					),
				],
			}),
		);
	};
